const BaseView = require('../components/common/common-component');
const AnalyticsDecorate = require('../../../analytics/decorate');
const ImagesView = require('../images/stock');
const IconsView = require('../icons/stock');

module.exports = AnalyticsDecorate(require('./analytics/view'), BaseView.extend({
  type: 'search',

  show: function () {
    const isAlreadyThere = this.$el.find('.tab-content.search').length;

    isAlreadyThere
      ? this.refresh()
      : this.render();
  },

  render: async function () {
    await BaseView.prototype.render.call(this);

    this.isKW = INKIVE.C.USER.kw_uid !== undefined;
    this.$headerLinks.filter('[data-key=images]').trigger('click');
  },

  initImagesView: function () {
    this.registerTabView('images', new ImagesView({
      el: this.$el.find('.tab-content > .images'),
      simplified: true,
      isAssetBankCompany: this.isAssetBankCompany,
      isKW: this.isKW
    }));
  },

  initIconsView: function () {
    this.registerTabView('icons', new IconsView({
      el: this.$el.find('.tab-content > .icons'),
      simplified: true,
      isKW: this.isKW
    }));
  }
}));
